import actions from '../actions';

const initState = [];

export default function cartReducer(state = initState, action) {
  switch (action.type) {
    case actions.cart.INIT:
      return [];
    case actions.cart.SET_STATE:
      return [...action.payload];
    default:
      return state;
  }
}
